import { Add, Delete, Download, Edit } from "@mui/icons-material";
import CustomTable from "../../core/custom-table";
import { saveAs } from "file-saver";
import { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Tooltip,
} from "@mui/material";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import FormGenerator from "../../core/form-generator";
import { ClearIcon } from "@mui/x-date-pickers";
import { invokeUploadFile } from "../../utils/http-service";
import { HOSTNAME, REST_URLS } from "../../utils/endpoints";
import { toast } from "react-toastify";
import { generateCertificatePDF } from "./generate-certificate-pdf";

const TrainingRequestedCandidateList = ({
  participantsList,
  isOEM,
  onAddParticipant,
  onRemoveParticipant,
  isCompleted,
  isOEMRequested,
  courseDetails,
}) => {
  const trainingRequestedParticipantList = {
    HeaderConfig: [
      {
        label: "S l No.",
        id: "serialNumber",
      },
      {
        label: "Name of the Candidate",
        id: "name",
      },
      {
        label: "Age",
        id: "age",
      },
      {
        label: "Qualification",
        id: "qualification",
      },
      {
        label: "No. of years Experience",
        id: "experienceInYears",
      },
      {
        label: "Designation",
        id: "designation",
      },
      {
        label: "Photo",
        id: "photo",
        render: (data) => {
          return (
            <img
              className="mc-image"
              src={data?.photo?.split("?")[0]}
              alt={data.name}
            />
          );
        },
      },
      !isCompleted && {
        label: "Actions",
        id: "removeParticipant",
        render: (data) => {
          return (
            <>
              <div className="action-icons">
                <Delete
                  size="small"
                  onClick={() => openDeleteConfirmationModal(data)}
                />
                <Edit
                  size="small"
                  onClick={() => handleEditParticipant(data)}
                />
              </div>
            </>
          );
        },
      },
    ],
  };
  const fileInputRef = useRef(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isDeleteConfirmationModal, setIsDeleteConfirmationModal] =
    useState(false);
  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [currentParticipant, setCurrentParticipant] = useState(null);
  const [updateParticipantList, setUpdateParticipantList] = useState(false);
  const [selectedRow, setSelectedRow] = useState({});
  const trainingCertificateListOem = {
    HeaderConfig: [
      {
        label: "S l No.",
        id: "serialNumber",
      },
      {
        label: "Name of the Candidate",
        id: "name",
      },
      {
        label: "Age",
        id: "age",
      },
      {
        label: "Qualification",
        id: "qualification",
      },
      {
        label: "No. of years of Experience",
        id: "experienceInYears",
      },
      {
        label: "Designation",
        id: "designation",
      },
      {
        label: "Photo",
        id: "photo",
        render: (data) => {
          return (
            <img
              className="mc-image"
              src={data?.photo?.split("?")[0]}
              alt={data.name}
            />
          );
        },
      },
      isCompleted && {
        label: "Download Certificate",
        id: "certificate",
        render: (data) => {
          return (
            <>
              <div className="download-icon">
                <Download
                  size="small"
                  onClick={() => downloadCertificate(data)}
                />
              </div>
            </>
          );
        },
      },
    ],
  };

  useEffect(() => {
    setUpdateParticipantList([...participantsList]);
  }, []);

  const updateParticipantDetailsForm = () => [
    {
      label: "Name of the Candidate",
      name: "name",
      type: "text",
      required: true,
    },
    {
      label: "Age",
      name: "age",
      type: "number",
      required: true,
    },
    {
      label: "Qualification",
      name: "qualification",
      type: "text",
      required: true,
    },
    {
      label: "No. of years Experience",
      name: "experienceInYears",
      type: "number",
      required: true,
    },
    {
      label: "Designation",
      name: "designation",
      type: "text",
      required: true,
    },
  ];

  const handleRemove = () => {
    const updatedList = participantsList.filter(
      (item) => item.serialNumber !== selectedRow?.serialNumber
    );
    setUpdateParticipantList([...updatedList]);
    setIsDeleteConfirmationModal(false);
    onRemoveParticipant(updatedList);
  };

  const handleEditParticipant = (data) => {
    setCurrentParticipant({ ...data }); // Populate modal with row data
    setFormData({ ...data });
    setIsModalOpen(true); // Open modal
  };

  const downloadCertificate = (data) => {
    generateCertificatePDF(data, courseDetails);
  };

  const addParticipant = () => {
    setFormData({});
    setIsModalOpen(true);
    //setUpdateParticipantList(!updateParticipantList);
  };

  const handleSave = () => {
    let updatedList = [];
    if (currentParticipant) {
      updatedList = participantsList.map((participant) =>
        participant.serialNumber === currentParticipant.serialNumber
          ? { ...formData }
          : participant
      );
    } else {
      participantsList.push({
        serialNumber: participantsList.length + 1,
        ...formData,
      });
      updatedList = participantsList;
      setUpdateParticipantList([...participantsList]);
    }
    onAddParticipant(updatedList); // Update list via prop
    setIsModalOpen(false); // Close modal
  };

  const fileUpload = (file) => {
    const formData = new FormData();
    formData.append("upload", file);
    return invokeUploadFile(
      `${HOSTNAME}${REST_URLS.UPLOAD_FILE}${123}`,
      formData
    )
      .then((response) => {
        if (response.status === 200) {
          toast.success("Uploaded Successfully");
          return {
            url: response?.data?.url,
            name: response?.data?.originalname,
          };
          //callBack && callBack(response.data);
        } else {
          toast.error(
            (response.data && response.data.message) || "Upload Failed"
          );
          //setUploadStatus("");
        }
      })
      .catch((err) => {
        //setUploadStatus("Upload Failed");
        toast.error("Upload Failed");
      });
  };

  const onImageUpdate = (data) => async (event) => {
    if (event.target.files[0]) {
      let updatedValue = await fileUpload(event.target.files[0]);
      setFormData((prev) => ({
        ...prev,
        photo: updatedValue.url,
      }));
    }
  };

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const clearFile = (data) => (event) => {
    setFormData((prev) => ({
      ...prev,
      photo: null,
    }));

    if (fileInputRef.current) {
      fileInputRef.current.value = ""; // Clear the input field
    }
  };

  const openDeleteConfirmationModal = (data = []) => {
    setSelectedRow({ ...data });
    setIsDeleteConfirmationModal(!isDeleteConfirmationModal);
  };

  return (
    <>
      <div className="training-request-candidate-list-container">
        <div className="title-container">
          <div className="participant-list-title">Participants List</div>
          {!isOEM && !isCompleted && !isOEMRequested && (
            <Tooltip title="Add Participant" arrow>
              <Add onClick={() => addParticipant()} />
            </Tooltip>
          )}
        </div>
        <div className="list-container">
          <CustomTable
            header={
              isOEM
                ? trainingCertificateListOem.HeaderConfig
                : isOEMRequested
                ? trainingRequestedParticipantList.HeaderConfig.filter(
                    (data) => data.id !== "removeParticipant"
                  )
                : trainingRequestedParticipantList.HeaderConfig
            }
            data={updateParticipantList || []}
            //pageCount={pastTickets.totalPages}
            //onClick={onRowClick}
            //filters={filters}
            /* onChange={(page) => {
                        setFilters({
                        ...filters,
                        page,
                        }); */
            /* loadData({
                        ...filters,
                        page,
                        }); */
            //}}
          />
        </div>

        <Dialog
          sx={{ m: 0, p: 2, "&.MuiDialogTitle-root": { "font-weight": "600" } }}
          id="customized-dialog-title"
          open={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        >
          <DialogTitle>Edit Participant</DialogTitle>
          <DialogContent
            dividers
            sx={{ "&.MuiDialogContent-dividers": { border: 0 } }}
          >
            <>
              <FormGenerator
                config={updateParticipantDetailsForm()}
                formData={formData}
                setFormData={setFormData}
                errors={errors}
                setErrors={setErrors}
                onChange={handleInputChange}
                fieldGridSize={5}
              />
              <>
                Candidate Photo
                {!formData?.photo ? (
                  <>
                    <IconButton component="label">
                      <AttachFileIcon size="small" />
                      <input
                        id="photo"
                        type="file"
                        hidden
                        onChange={onImageUpdate(formData)}
                        ref={fileInputRef}
                        accept="image/png, image/gif, image/jpeg"
                      />
                    </IconButton>
                  </>
                ) : (
                  formData?.photo && (
                    <>
                      <Box
                        style={{
                          "border-radius": "6px",
                          width: "fit-content",
                          display: "flex",
                          alignItems: "center",
                          padding: "6px 8px",
                        }}
                      >
                        <Tooltip title={formData?.photo.split("?")[0]} arrow>
                          <p
                            style={{
                              fontSize: 14,
                              "margin-left": "8px",
                              "margin-top": "6px",
                              "margin-right": "10px",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "200px",
                            }}
                          >
                            <img
                              src={formData?.photo.split("?")[0]}
                              alt={formData.name}
                              style={{
                                width:
                                  "100px" /* Adjust to your desired width */,
                                height: "auto" /* Maintain aspect ratio */,
                                "object-fit": "cover",
                              }}
                            />
                          </p>
                        </Tooltip>
                        <ClearIcon
                          size="small"
                          color="black"
                          sx={{
                            color: "black",
                            "margin-top": "1px",
                            "margin-right": "6px",
                            "margin-bottom": "6px",
                            cursor: "pointer",
                          }}
                          onClick={clearFile(formData)}
                        />
                      </Box>
                    </>
                  )
                )}
              </>
            </>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setIsModalOpen(false)}>Cancel</Button>
            <Button onClick={handleSave} color="primary">
              Save
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          sx={{
            m: 0,
            p: 2,
            "&.MuiDialogTitle-root": { "font-weight": "600" },
            "& .MuiDialog-paper": { width: "600px", maxWidth: "none" },
          }}
          id="customized-dialog-title"
          open={isDeleteConfirmationModal}
          onClose={() => openDeleteConfirmationModal()}
        >
          <DialogTitle>Delete Participant</DialogTitle>
          <DialogContent
            dividers
            sx={{ "&.MuiDialogContent-dividers": { border: 0 } }}
          >
            Are you sure you want delete the participant?
          </DialogContent>
          <DialogActions>
            <Button onClick={() => openDeleteConfirmationModal()}>
              Cancel
            </Button>
            <Button onClick={() => handleRemove()} color="primary">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    </>
  );
};

export default TrainingRequestedCandidateList;
